import { ApiError } from "@nabble/sdk";
import { errorMessage } from "../../../../errors";

/** How many secondary emails a person can have. */
export const MAX_EMAILS = 5;

const EMAIL_MESSAGES: Record<string, string> = {
  invalid_credentials: "Your current password isn't correct.",
  email_taken: "That email already belongs to an account. If it's one of yours, check the list below.",
  too_many_emails: `You can have up to ${MAX_EMAILS} other emails. Remove one to add another.`,
  not_verified: "Confirm this email first: open the link we sent to it.",
  validation: "Enter a valid email address, like name@example.com.",
};

/** Plain message for the email endpoints' error codes; anything else goes through the shell's mapping. */
export function emailErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiError) {
    const known = EMAIL_MESSAGES[err.code];
    if (known) return known;
  }
  return errorMessage(err, fallback);
}

export interface FormErrors {
  email?: string;
  password?: string;
  other?: string;
}

/** Puts each error next to the field it's about. */
export function formErrors(err: unknown, fallback: string): FormErrors {
  const code = err instanceof ApiError ? err.code : null;
  const message = emailErrorMessage(err, fallback);
  if (code === "invalid_credentials") return { password: message };
  if (code === "email_taken" || code === "validation") return { email: message };
  return { other: message };
}
